import { apiVersion, siteUrl, urlAPI, version } from "./../constants/constants";
import axios from "axios";
import cookie from "js-cookie";
import { isMobile } from "react-device-detect";
import { notification, message } from "antd";

const queryString = require("query-string");
let parsed = queryString.parse(window.location.search);

const instance = axios.create({
  baseURL: urlAPI,
});

instance.interceptors.request.use(
  (config) => {
    let token = cookie.get("token");
    if (parsed.token) token = parsed.token;

    if (token) {
      config.timeout = 3600000;
      config.headers["Authorization"] = "Bearer " + token;
    }

    config.headers["Version"] = version;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

export const openNotificationWithIcon = (title: any, message: any) => {
  notification["error"]({
    message: title,
    description: message,
    duration: 10,
  });
};

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const login = cookie.get("login");
      const password = cookie.get("password");

      if (!login || !password) {
        return Promise.reject(error);
      }

      // Try request again with new token
      return api
        .login(login, password)
        .then((res) => {
          if (!res?.token) {
            return Promise.reject(error);
          }

          // New request with new token
          const config = error.config;
          cookie.set("token", res.token);
          config.headers["Authorization"] = "Bearer " + res.token;
          config.headers["Version"] = version;

          return new Promise((resolve, reject) => {
            axios
              .request(config)
              .then((response) => {
                resolve(response);
              })
              .catch((error) => {
                reject(error);
              });
          });
        })
        .catch(() => {
          return Promise.reject(error);
        });
    } else {
      return Promise.reject(error);
    }
  },
);

export const api = {
  login(login: string, password: string) {
    return instance
      .post("users/auth", {
        login: login,
        psw: password,
        type: isMobile ? "web-mobile" : "web",
        model: navigator.userAgent,
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        if (
          err.response.data &&
          err.response.data === "Неверный логин или пароль"
        ) {
          cookie.remove("login");
          cookie.remove("password");
          cookie.remove("token");
          cookie.remove("userData");
          cookie.remove("shop");
          cookie.remove("supplier");

          window.location.reload();
        }
        console.log(err);
      });
  },

  loginCheck(login: string) {
    return instance
      .post("users/valid", {
        login: login,
      })
      .then((res) => {
        return true;
      })
      .catch((err) => {
        return false;
      });
  },

  loginByToken(token: string) {
    return instance
      .post("users/auth/data", {
        token: token,
      })
      .then((res) => {
        return res.data;
      })
      .catch((err) => {});
  },

  changePsw(oldpsw: string, newpsw: string) {
    return instance
      .post("users/psw", {
        oldpsw: oldpsw,
        newpsw: newpsw,
      })
      .then((res) => {
        return true;
      })
      .catch((err) => {
        let error = err.response.data.msg ? err.response.data.msg : null;
        if (error) {
          message.info(error);
        }

        return undefined;
      });
  },

  verifyUser(code: string) {
    return instance
      .get("users/signup/" + code)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  signupUser(login: any, psw: any, name: any, email: any, oktmo: any) {
    return instance
      .post("users/signup", {
        login: login,
        psw: psw,
        name: name,
        email: email,
        oktmo: oktmo,
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getClientObjects(tbl: string) {
    return instance
      .get("client" + apiVersion + "/object/" + tbl)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getClientObjectsWithOptions(name: string, options: any) {
    return instance
      .post("client" + apiVersion + "/object/" + name + "/loadoptions", options)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  addClientObject(tbl: string, dataRow: any) {
    return instance
      .post("client" + apiVersion + "/object/" + tbl, dataRow)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  editClientObject(tbl: string, dataRow: any) {
    return instance
      .put("client" + apiVersion + "/object/" + tbl, dataRow)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  requestAnyTraderShopsSuppliers(tbl: string, json: any) {
    //return instance.post('client' + apiVersion + '/' + tbl, json)
    //    .then(res => res.data)
    //    .catch(err => console.log(err))

    return instance
      .post("client" + apiVersion + "/" + tbl, json)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        let error = err.response.data.message
          ? err.response.data.message
          : null;
        let phone = err.response.data.phone ? err.response.data.phone : null;

        if (error) {
          if (err.response.data.isResult) {
            return {
              modal: true,
              message: error,
              data: err.response.data,
            };
          } else {
            openNotificationWithIcon(
              "Ошибка",
              error + (phone ? " Позвоните по номеру: " + phone : ""),
            );
          }
        }

        return undefined;
      });
  },

  getPromoByShop(supplierCode: string, shopCode: string) {
    return instance
      .get("/promo/" + supplierCode + "/" + shopCode)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getProductsPromoByShop(
    supplierCode: string,
    shopCode: string,
    promoCode: string,
  ) {
    return instance
      .get(
        "client" +
          apiVersion +
          "/products-by-promo?supplier=" +
          supplierCode +
          "&shop=" +
          shopCode +
          "&promo=" +
          promoCode,
      )
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  requestCheckPromo(tbl: string, json: any) {
    return instance
      .post("client" + apiVersion + "/" + tbl, json)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        return undefined;
      });
  },

  requestGetClient(json: any) {
    return instance
      .post("client" + apiVersion + "", json)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  requestGetClientAnonym(json: any) {
    return instance
      .post("client" + apiVersion + "/anonym", json)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getContractClient(json: any) {
    return instance
      .post("client" + apiVersion + "/contract", json)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  editObject(tbl: string, dataRow: any) {
    return instance
      .put("objects/" + tbl, dataRow)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  deleteObject(tbl: string, code: any) {
    return instance
      .delete("objects/" + tbl + "/" + code)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getClientObjectDataRow(tbl: string, code: any) {
    return instance
      .get("client" + apiVersion + "/objects/" + tbl + "/" + code)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getClientObjectFields(tbl: string) {
    return instance
      .get("client/objects/" + tbl + "/fields")
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getMenu(system: string, code: string | null) {
    let url = system + "/menu";

    if (code) {
      url += "?parent_code=" + code;
    }

    return instance
      .get(url)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  addRepoFile(
    obj: string,
    obj_code: string,
    supplier_code: string | null,
    file: File,
  ) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("supplier", supplier_code ? supplier_code : "");
    formData.append("obj", obj);
    formData.append("obj_code", obj_code);

    return instance
      .post("repo/upload", formData)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getRepoFile(code: string) {
    return instance
      .get("repo/" + code)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  deleteRepoFile(code: string) {
    return instance
      .delete("repo/" + code)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  sendForgotPsw(email: string) {
    return axios
      .post("users/forgot", { email })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  sendForgotNewPsw(code: string, pwd: string) {
    return instance
      .post("users/forgot", { code, pwd })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  //OBJECT
  getObjects(tbl: string) {
    return instance
      .get("objects/" + tbl)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getObjectsWithOptions(name: string, options: any) {
    return instance
      .post("objects/" + name + "/loadoptions", options)

      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  addObject(tbl: string, dataRow: any) {
    return instance
      .post("objects/" + tbl, dataRow)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getObjectDataRow(tbl: string, code: any) {
    return instance
      .get("objects/" + tbl + "/" + code)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getObjectFields(tbl: string) {
    return instance
      .get("objects/" + tbl + "/fields")
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getSuppliers(cmd: string) {
    return instance
      .get("suppliers/" + cmd)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  postSuppliers(tbl: string, json: any) {
    return instance
      .post("suppliers/" + tbl, json)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getAdminSuppliers(tbl: string, status: string, code_suppliers: string) {
    return instance
      .get(
        "admin/suppliers/" +
          tbl +
          "?status=" +
          status +
          "&code=" +
          code_suppliers,
      )
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getAdmin(table: string, cmd: string) {
    return instance
      .get("admin/" + table + cmd)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  editAdmin(tbl: string, data: any) {
    return instance
      .put("admin/" + tbl, data)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getOrderUsers(params: any) {
    const qs = queryString.stringify(params, {
      skipNull: true,
      skipEmptyString: true,
    });
    return instance
      .get("admin/order-users" + (qs ? "?" + qs : ""))
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  postOrderUser(json: any) {
    return instance
      .post("admin/order-users", json)
      .then((res) => res.data)
      .catch((err: any) => {
        if (err?.response?.data)
          message.error(
            typeof err.response.data === "string"
              ? err.response.data
              : JSON.stringify(err.response.data),
          );
        else message.error("Произошла ошибка");
        return undefined;
      });
  },

  getOrderUserOptions(params: any) {
    const qs = queryString.stringify(params, {
      skipNull: true,
      skipEmptyString: true,
    });
    return instance
      .get("admin/order-user-options" + (qs ? "?" + qs : ""))
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  addEditAdmin(tbl: string, json: any) {
    return instance
      .post("admin/" + tbl, json)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  deleteAdmin(tbl: string, code: any) {
    return instance
      .delete("admin/" + tbl + "/" + code)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getAdminObj(tbl: string) {
    return instance
      .get("admin/obj/" + tbl)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getAdminOptionsObj(tbl: string, options: any) {
    return instance
      .post("admin/obj/" + tbl + "/loadoptions", options)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  addAdminObj(tbl: string, data: any) {
    return instance
      .post("admin/obj/" + tbl, data)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  editAdminObj(tbl: string, data: any) {
    return instance
      .put("admin/obj/" + tbl, data)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  deleteAdminObj(tbl: string, code: any) {
    return instance
      .delete("admin/obj/" + tbl + "/" + code)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getAnalyze(json: any) {
    return instance
      .post("analyze", json)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  requestWebSborGks(inn: string) {
    return instance
      .post("https://agro-info.sakha.gov.ru/apimsh/statement/websbor", {
        inn: inn,
        hash: "628DD8639F56B672AD3292392BC49907",
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  setUsersInfo(fld: any, code: any) {
    return instance
      .get("users/" + fld + "/" + code)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  addInnUser(inn: string, name: string) {
    return instance
      .post("users/inn", {
        inn: inn,
        name: name,
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getInnUser() {
    return instance
      .get("users/inn")
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getUser() {
    return instance
      .get("users")
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getSMS(phone: string, type: string, country: string) {
    return instance
      .post("users/" + type, {
        phone: phone,
        country: country,
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getPhoneVerify(phone: string, code: string, type: string) {
    return instance
      .post("users/" + type + "/verify", {
        phone: phone,
        code: code,
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  deleteInn(inn: string) {
    return instance
      .delete("users/inn/" + inn)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  changePSWUser(login: string, psw: string, code: string) {
    return instance
      .post("users/forgot", {
        login: login,
        psw: psw,
        code: code,
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  saveFastOrder(
    cmd: string,
    supplier_code: string,
    data: any,
    toCheckOrder: boolean,
    order_properties: any,
    comment: any,
  ) {
    return instance
      .post("client" + apiVersion + "/order", {
        cmd: cmd,
        toCheckOrder: toCheckOrder,
        supplier: supplier_code,
        json_data: data,
        delivery: "1",
        order_properties: order_properties,
        comment: comment,
      })
      .then((res) => res.data)
      .catch((err: any) => {
        let error = err.response.data.msg ? err.response.data.msg : null;
        if (error) {
          message.error(error, 10);
        } else if (err.response.data?.message) {
          message.error(err.response.data?.message, 10);
        }

        return undefined;
      });
  },

  getHistoryOrder(
    cmd: string,
    supplier_code: string,
    rowSkip: number,
    rowCount: number,
  ) {
    return instance
      .post("client" + apiVersion + "/order", {
        cmd: cmd,
        supplier: supplier_code,
        rowSkip: rowSkip,
        rowCount: rowCount,
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getDashboardData(year: any) {
    return instance
      .get("suppliers/reports?period=" + year + "&tip=svod")
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getDashboardContracts(year: any) {
    return instance
      .get("suppliers/reports?period=" + year + "&tip=contracts")
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  postMetrica(obj: any) {
    return instance
      .post("analyze/obrab", obj)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  postDynamicaProdaj(json: any) {
    return instance
      .post("analyze/sales/dynamics", json)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  postDynamicaProdajProducts(json: any) {
    return instance
      .post("analyze/sales/by-product", json)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getProductsRetaily(obj: any) {
    return instance
      .get("admin/products?" + obj)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
  putProductsRetaily(obj: any) {
    return instance
      .put("admin/products?cat_type=retaily", obj)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  postProdajiShop(json: any) {
    return instance
      .post("client" + apiVersion + "/supplier/products/count", json)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  clearSupplierData(token: string, login: string) {
    return instance
      .post("suppliers/clear?access_token=" + token, {
        reason: "Был удален с админки - пользователь: " + login,
      })
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getNotifications(params?: {
    rowSkip?: number;
    rowCount?: number;
    type?: string;
    supplier?: string;
    unreadOnly?: boolean;
  }) {
    let query: string[] = [];

    if (params) {
      if (params.rowSkip !== undefined) query.push("rowSkip=" + params.rowSkip);
      if (params.rowCount !== undefined)
        query.push("rowCount=" + params.rowCount);
      if (params.type) query.push("type=" + encodeURIComponent(params.type));
      if (params.supplier)
        query.push("supplier=" + encodeURIComponent(params.supplier));
      if (params.unreadOnly !== undefined)
        query.push("unreadOnly=" + params.unreadOnly);
    }

    let url = "Notifications" + (query.length ? "?" + query.join("&") : "");

    return instance
      .get(url)
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  getNotificationsUnreadCount() {
    return instance
      .get("Notifications/unread-count")
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  markNotificationRead(code: string) {
    return instance
      .post("Notifications/" + encodeURIComponent(code) + "/read")
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  markAllNotificationsRead() {
    return instance
      .post("Notifications/read-all")
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },

  deleteNotification(code: string) {
    return instance
      .delete("Notifications/" + encodeURIComponent(code))
      .then((res) => res.data)
      .catch((err) => console.log(err));
  },
};
